// Keep the Qstar purchase selector and Sleek 2.3.0 native sticky bar available.
// Only the selected template is mounted, so product forms and IDs stay unique.
if (!customElements.get('qstar-sticky-atc-router')) {
  customElements.define('qstar-sticky-atc-router', class extends HTMLElement {
    static scripts = new Map();

    connectedCallback() {
      this.templates = {
        qstar: this.querySelector('[data-qstar-sticky-template]'),
        native: this.querySelector('[data-native-sticky-template]'),
      };
      this.onSectionLoad = () => this.reconcile();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.reconcile();
      if (window.Shopify?.designMode) {
        this.observer = new MutationObserver(() => this.reconcile());
        this.observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.observer?.disconnect();
    }

    reconcile() {
      const productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
      if (!productInfo) return;
      const kind = productInfo.querySelector('[data-pdp-sticky-atc-enabled]') ? 'qstar' : 'native';
      if (this.kind === kind && this.productInfo === productInfo) return;
      this.kind = kind;
      this.productInfo = productInfo;
      this.content?.remove();
      this.content = document.createElement('div');
      const fragment = this.templates[kind].content.cloneNode(true);
      const scripts = [...fragment.querySelectorAll('script[src]')];
      scripts.forEach((script) => script.remove());
      this.content.appendChild(fragment);
      this.appendChild(this.content);
      // Scripts in HTML templates must be explicitly loaded when mounted.
      scripts.forEach((source) => {
        if (this.constructor.scripts.has(source.src)) return;
        const script = document.createElement('script');
        script.src = source.src;
        script.async = false;
        this.constructor.scripts.set(source.src, script);
        script.addEventListener('error', () => {
          this.constructor.scripts.delete(source.src);
          console.error('Could not load sticky cart component:', source.src);
        });
        document.head.appendChild(script);
      });
    }
  });
}
